<div class="menu" #menuContainer>
  @for (item of menuItems() | sortBy: 'asc' : 'meta.rank'; track item.id) {
    @if (item.meta?.useRouterLink) {
      <div class="menu__item">
        <div class="menu__item__overlay" [routerLink]="item.link"></div>
        <div
          class="menu__item__icon"
          [class.selected]="item.meta?.urlMatches | tsMutateToAny: $any(isUrlMatches).bind(lastUrl())"
        >
          <lucide-icon [name]="iconMap[item.icon] ?? item.icon"></lucide-icon>
        </div>
        <span class="menu__item__title">{{ item.title }}</span>
      </div>
    } @else {
      <div class="menu__item">
        <div
          class="menu__item__overlay"
          [routerLink]="item.link"
          (click)="onNavigate()"
          (mouseenter)="hover.next(item)"
          (mouseleave)="hover.next(undefined)"
        ></div>
        <div
          class="menu__item__icon"
          [class.selected]="item.meta?.urlMatches | tsMutateToAny: $any(isUrlMatches).bind(lastUrl())"
        >
          <lucide-icon [name]="iconMap[item.icon] ?? item.icon"></lucide-icon>
        </div>
        <span class="menu__item__title">{{ item.title }}</span>
      </div>
    }
  }
</div>

<ts-overlay
  #menuOverlayBox
  [position]="{
    offsetX: 8,
    offsetY: 0,
    originX: 'end',
    originY: 'top',
    overlayX: 'start',
    overlayY: 'top',
  }"
  cssClass="ts-overlay-menu"
  [hasBackdrop]="false"
  [transparentBackdrop]="true"
  (closeByBackdropClick)="isOverlayOpenFor.set(undefined)"
>
  @if (isOverlayOpenFor(); as info) {
    <div
      class="menu-overlay-content"
      [class.projects]="info.id === 'projects'"
      [ngClass]="{ 'multi-groups': info.id === 'reporting' || info.id === 'tasks' }"
      (mouseenter)="hover.next(info)"
      (mouseleave)="hover.next(undefined)"
    >
      @switch (info.id) {
        @case ('projects') {
          <app-deals-sidebar [showRecent]="true" (onNavigate)="onNavigate()"></app-deals-sidebar>
        }
        @case ('contacts') {
          <app-shell-view-loader [identifier]="info" (onNavigate)="onNavigate()"></app-shell-view-loader>
        }
        @case ('companies') {
          <app-shell-view-loader [identifier]="info" (onNavigate)="onNavigate()"></app-shell-view-loader>
        }
        @case ('properties') {
          <app-shell-view-loader [identifier]="info" (onNavigate)="onNavigate()"></app-shell-view-loader>
        }
        @case ('tasks') {
          <app-shell-task-sidebar (onNavigate)="onNavigate()"></app-shell-task-sidebar>
        }
        @case ('reporting') {
          <app-shell-report-sidebar (onNavigate)="onNavigate()"></app-shell-report-sidebar>
        }
        @default {
          <app-shell-view-loader [identifier]="info" (onNavigate)="onNavigate()"></app-shell-view-loader>
        }
      }
    </div>
  }
</ts-overlay>
